import * as React from "react";
import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import { LabelContext } from "../core/label.context";
import { GeneralContext } from "../core/general.context";
import { CartContext } from "../core/cart.context";
import { calls } from "../core/APIUtils";
import { RESTContext } from "../core/rest.context";
import { getAnalyticsProducts, parsePrice, redirectTo } from "../common/constants";
import {ThankYouMessage} from "./CheckoutPage";

export const YounitedConfirmationPage = (_props: any) => {
    const [younitedInfo, setYounitedInfo] = useState<any>();
    const [younitedOrderConfirmed, setYounitedOrderConfirmed] = useState<any>();
    const container = document.getElementById("reactPlaceholder_younited-confirmation");
    const { t } = React.useContext(LabelContext);
    const { userData, younitedOrder } = React.useContext(GeneralContext);
    const { confirmYounitedContract } = React.useContext(CartContext);
    const { ajax$ } = React.useContext(RESTContext);
    const localStorage = (window as any).localStorage || []
    const dataLayer = (window as any).dataLayer || []
    const analytics: any = localStorage?.analytics ? JSON.parse(localStorage?.analytics) : {}

    useEffect(() => {
        let params: URLSearchParams = new URLSearchParams(window.location.search)
        if (params?.get("ypcid") && params?.get("paymentId")) {
            const sid: string = params?.get("ypcid") || ""
            const paymentId: string = params?.get("paymentId") || ""
            setYounitedInfo({cartId: sid, paymentId})
        }
    }, [])

    useEffect(() => {
        if (younitedInfo) {
            confirmYounitedContract(younitedInfo.cartId, younitedInfo.paymentId)
        }
    }, [younitedInfo])

    useEffect(() => {
        if (younitedOrder) {
            if (younitedOrder.code > 302){
                redirectTo('checkout?status=error');
            }
            else if (younitedOrder?.obj?.ctOrder) {
                setYounitedOrderConfirmed(younitedOrder.obj.ctOrder);
            } else {
                if (younitedOrder?.obj?.cartId) {
                    ajax$(calls.Project.getMyCartById(younitedOrder?.obj?.cartId))
                        .subscribe(
                            res => {
                                setYounitedOrderConfirmed(res);
                            }
                        );
                } 
            }
        }
    }, [younitedOrder])

    useEffect(() => {
        if (younitedOrderConfirmed) {
            dataLayer.push({
                pageLang: `${analytics?.currentLang || ""}`,
                pageType: `${younitedOrderConfirmed ? "purchase" : analytics?.pageType}`,
                visitorId: `${userData?.id}`,
                visitorLoginState: `${userData?.id ? "logged-in" : "not-logged"}`,
                visitorNewsletterSubscription: `${userData?.custom?.fields?.subscribed ? "yes" : "no"}`,
            })

            dataLayer.push({
                event: "checkoutOption",
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 2,
                            option: [
                                `${younitedOrderConfirmed?.shippingInfo?.shippingMethodName} - ${younitedOrderConfirmed?.paymentInfo?.payments[0]?.obj?.paymentMethodInfo?.paymentInterface}`,
                            ],
                        },
                    },
                },
            })

            dataLayer.push({
                event: "doofinder_checkout",
                hashid: "event.detail.tag._hashid",

            })

            const { lineItems } = younitedOrderConfirmed

            dataLayer.push({
                pageType: "purchase",
                visitorId: `${userData?.id}`,
            })
            dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    currencyCode: `${younitedOrderConfirmed?.totalPrice?.currencyCode}`,
                    purchase: {
                        actionField: {
                            id: `${younitedOrderConfirmed?.orderNumber}`,
                            affiliation: 'Online store',
                            revenue: `${parsePrice(younitedOrderConfirmed?.totalPrice, true)}`,
                            tax: `${parsePrice(younitedOrderConfirmed?.taxedPrice?.taxPortions[0]?.amount, true)}`,
                            shipping: `${younitedOrderConfirmed?.shippingInfo?.price?.centAmount}`,
                            coupon: `${younitedOrderConfirmed?.discountCodes?.map((item: any) => { return item?.discountCode?.obj?.code }).toString()}`,
                        },
                        products: getAnalyticsProducts(lineItems),
                    }
                }
            });
        } else {
            dataLayer.push({
                'pageLang': `${analytics?.currentLang}`,
                'pageType': `${analytics?.pageType ? analytics?.pageType : (analytics?.sitemap === 'root') ? 'homepage' : 'other'}`,
                'visitorId': `${userData?.id}`,
                'visitorLoginState': `${userData?.id ? 'logged-in' : 'not-logged'}`,
                'visitorNewsletterSubscription': `${userData?.custom?.fields?.subscribed ? 'yes' : 'no'}`,
            });
        }
    }, [younitedOrderConfirmed])

    if (!container)
        return null;
    else
        return ReactDOM.createPortal(
            <>
            {!younitedOrderConfirmed && <div className="isLoading" />}
            {younitedOrderConfirmed && <ThankYouMessage currentOrder={younitedOrderConfirmed} />}
            </>
            , container
        )
}
